export default "__VITE_ASSET__DEDU6kNU__"